import watchServiceWorkerUpdate from '@Infra/ServiceWorker/watchServiceWorkerUpdate';

export type WatchApplicationUpdateOptions = {
	readonly onUpdateAvailable: (applyUpdate: () => void) => void;
};

/**
 * Wraps the raw `ServiceWorkerRegistration` behind a ready-to-call `applyUpdate` closure, so that
 * no service worker type ever crosses into a consumer such as `useApplicationUpdate`: it only
 * learns that an update is waiting, and gets a function to apply it.
 *
 * Posting the `SKIP_WAITING` message to the registration's `waiting` worker — never to its active
 * `controller` — is what actually triggers the new worker's install-time handler; the active
 * worker would silently ignore the message, leaving the update permanently unapplied.
 */
const watchApplicationUpdate = (options: WatchApplicationUpdateOptions): (() => void) => {
	return watchServiceWorkerUpdate({
		onUpdateAvailable: (registration) => {
			options.onUpdateAvailable(() => {
				registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
			});
		},
	});
};

export default watchApplicationUpdate;
